import RealTime from './RealTime';

export default RealTime;
